import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const ArrowRightSimple = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 20}
        height={size ?? 20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.4 15.0583C11.4 14.9 11.4583 14.7417 11.5833 14.6167L16.2 10L11.5833 5.38334C11.3417 5.14167 11.3417 4.74167 11.5833 4.50001C11.825 4.25834 12.225 4.25834 12.4667 4.50001L17.525 9.55834C17.7667 9.80001 17.7667 10.2 17.525 10.4417L12.4667 15.5C12.225 15.7417 11.825 15.7417 11.5833 15.5C11.4583 15.3833 11.4 15.2167 11.4 15.0583Z"
          fill={color}
        />
        <path
          d="M2.29165 10C2.29165 9.65833 2.57498 9.375 2.91665 9.375L16.9417 9.375C17.2833 9.375 17.5667 9.65833 17.5667 10C17.5667 10.3417 17.2833 10.625 16.9417 10.625L2.91665 10.625C2.57498 10.625 2.29165 10.3417 2.29165 10Z"
          fill={color}
        />
      </svg>
    );
  },
);
export default ArrowRightSimple;
